import { gql } from "@apollo/client"

export const ENGAGEMENTS = gql`
  query Engagements($staff_id: ID, $idTemplate: ID!) {
    engagements: blocksSavedByIdTemplate(
      staff_id: $staff_id
      idTemplate: $idTemplate
      groupByIdStamp: true
    ) {
      data
    }
  }
`

export const GET_SAVED_BLOCKS = gql`
  query Engagements($staff_id: ID, $idTemplate: ID!) {
    engagements: blocksSavedByIdTemplate(
      staff_id: $staff_id
      idTemplate: $idTemplate
      groupByIdStamp: true
    ) {
      data
    }
  }
`

export const GET_SAVED_BLOCKS_BY_SELECTED_STAFF = gql`
  query TemplateSavedByStaffIdSelector(
    $staff_id: ID!
    $organization_id: ID!
    $idTemplate: ID!
    $staff_selector_id: ID!
  ) {
    TemplateSavedByStaffIdSelector(
      staff_id: $staff_id
      organization_id: $organization_id
      idTemplate: $idTemplate
      staff_selector_id: $staff_selector_id
    ) {
      data
    }
  }
`

export const GET_SUPERVISOR = gql`
  query user($staff_id: ID!, $organization_id: ID!) {
    user(staff_id: $staff_id, organization_id: $organization_id) {
      staff_name_first
      staff_name_last
    }
  }
`
